export enum PersonalReturnStepState
{
    NotPlannedYet = "NotPlannedYet",
    Planned = "Planned",
    Canceled = "Canceled",
    CanceledDespitePlanned = "CanceledDespitePlanned",
    MeetingOk = "MeetingOk",
    Omitted = "Omitted",
    TimeToMeet = "TimeToMeet"
}
